// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as ProductPrice$Showside from "./ProductPrice.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as StoreProvider$Showside from "../context/StoreProvider.bs.js";
import * as ProductReviews$Showside from "./ProductReviews.bs.js";
import * as DynamicTruncate$Showside from "./DynamicTruncate.bs.js";
import * as ProductSwatches$Showside from "./ProductSwatches.bs.js";
function ProductListItem$ListItemButton(Props) {
  var className = Props.className;
  var children = Props.children;
  var blockOpt = Props.block;
  var style = Props.style;
  var hasTextOpt = Props.hasText;
  var enableActiveStateOpt = Props.enableActiveState;
  var onClickOpt = Props.onClick;
  var block = blockOpt !== undefined ? blockOpt : false;
  var hasText = hasTextOpt !== undefined ? hasTextOpt : false;
  var enableActiveState = enableActiveStateOpt !== undefined ? enableActiveStateOpt : true;
  var onClick = onClickOpt !== undefined ? onClickOpt : function (e) {};
  var display = block ? "block" : "inline-block";
  var display$1 = hasText ? display : Cn.make([display, "leading-0"]);
  var className$1 = Cn.make([CSS$Showside.prefix(display$1), CSS$Showside.prefix("cursor-pointer select-none"), enableActiveState ? CSS$Showside.prefix("dark-hover darker-active") : "", Belt_Option.getWithDefault(className, "")]);
  var tmp = {
    className: className$1,
    onClick: onClick
  };
  if (style !== undefined) {
    tmp.style = Caml_option.valFromOption(style);
  }
  return React.createElement("div", tmp, children);
}
ProductListItem$ListItemButton.displayName = "ProductListItem.ListItemButton";
var ListItemButton = {
  make: ProductListItem$ListItemButton
};
function ProductListItem(Props) {
  var isSelectedOpt = Props.isSelected;
  var product = Props.product;
  var variant = Props.variant;
  var productPriceStyle = Props.productPriceStyle;
  var shape = Props.shape;
  var imageFitStrategy = Props.imageFitStrategy;
  var titleLineClampOpt = Props.titleLineClamp;
  var flushedOpt = Props.flushed;
  var paddingOpt = Props.padding;
  var hideOutOfStockOpt = Props.hideOutOfStock;
  var heightOpt = Props.height;
  var imageSize = Props.imageSize;
  var onClick = Props.onClick;
  var classNameOpt = Props.className;
  var enableDataTestIdOpt = Props.enableDataTestId;
  var displayVariantByOpt = Props.displayVariantBy;
  var children = Props.children;
  var titleClassNameOpt = Props.titleClassName;
  var isSelected = isSelectedOpt !== undefined ? isSelectedOpt : false;
  var titleLineClamp = titleLineClampOpt !== undefined ? titleLineClampOpt : 3;
  var flushed = flushedOpt !== undefined ? flushedOpt : true;
  var padding = paddingOpt !== undefined ? paddingOpt : true;
  var hideOutOfStock = hideOutOfStockOpt !== undefined ? hideOutOfStockOpt : true;
  var height = heightOpt !== undefined ? heightOpt : "auto";
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var enableDataTestId = enableDataTestIdOpt !== undefined ? enableDataTestIdOpt : true;
  var displayVariantBy = displayVariantByOpt !== undefined ? displayVariantByOpt : /* FirstVariant */0;
  var titleClassName = titleClassNameOpt !== undefined ? titleClassNameOpt : "";
  var store = StoreProvider$Showside.use(undefined);
  var variant$1 = Belt_Option.getWithDefault(variant, Product$Showside.getVariantBySelector(product, displayVariantBy));
  var aspectRatioCn = typeof shape === "number" ? shape !== 2 ? shape !== 3 ? imageSize !== undefined ? "" : "aspect-ratio-square" : imageSize !== undefined ? "" : "aspect-ratio-2/3" : imageSize !== undefined ? "" : "aspect-ratio-4/3" : imageSize !== undefined ? "" : "aspect-ratio-square";
  var containerGridCols = imageSize !== undefined ? undefined : shape === 3 ? "grid-cols-4" : "grid-cols-3";
  var detailsColSpan = imageSize !== undefined ? "" : shape === 3 ? "col-span-3" : "col-span-2";
  var imageStyle = imageSize !== undefined ? {
    height: CSS$Showside.intToPx(imageSize[1]),
    width: CSS$Showside.intToPx(imageSize[0])
  } : undefined;
  var reviewSummary = product.reviewSummary;
  var heightCn = height === "full" ? "h-full" : "";
  return Belt_Option.mapWithDefault(Product$Showside.Media.getImage(variant$1.media), null, function (image) {
    var tmp = {
      className: CSS$Showside.prefix(Cn.make(["inline-block relative flex-shrink-0 rounded-custom overflow-hidden self-center", "w-full h-0", "bg-placeholder", aspectRatioCn]))
    };
    if (imageStyle !== undefined) {
      tmp.style = Caml_option.valFromOption(imageStyle);
    }
    var tmp$1 = {
      at: /* PLP */1,
      product: product,
      variant: variant$1
    };
    if (productPriceStyle !== undefined) {
      tmp$1.style = Caml_option.valFromOption(productPriceStyle);
    }
    var tmp$2 = {
      children: React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["flex-grow", heightCn])),
        onClick: function (param) {
          Curry._2(onClick, product, variant$1);
        }
      }, React.createElement(ProductListItem$ListItemButton, {
        className: Cn.make([CSS$Showside.prefix("group-2"), Belt_Option.mapWithDefault(containerGridCols, CSS$Showside.prefix("flex"), function (gridCols) {
          return CSS$Showside.prefix(Cn.make(["grid", gridCols]));
        }), Belt_Option.mapWithDefault(containerGridCols, CSS$Showside.prefix("space-x-4"), function (param) {
          return CSS$Showside.prefix("gap-4");
        }), CSS$Showside.prefix("rounded-custom"), CSS$Showside.prefix("border-0.5 border-solid"), isSelected ? CSS$Showside.prefix("border-accent") : CSS$Showside.prefix("border-transparent"), flushed && padding ? CSS$Showside.prefix("-mx-2.5") : "", padding ? CSS$Showside.prefix("p-2.5") : "", CSS$Showside.prefix(heightCn), className]),
        children: null,
        shadow: false,
        block: true,
        hasText: true,
        enableActiveState: false
      }, React.createElement("div", tmp, React.createElement(SmartImg$Showside.make, {
        src: image.url,
        fit: imageFitStrategy,
        alt: product.name,
        priority: 0
      })), React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make([detailsColSpan, "inline-flex flex-col self-center space-y-2"]))
      }, React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["text-secondary text-lg", titleClassName]))
      }, React.createElement(DynamicTruncate$Showside.make, {
        lines: titleLineClamp,
        dataTestId: "product-listitem-title",
        children: Product$Showside.getDisplayName(store, variant$1, product)
      })), React.createElement("div", {
        className: CSS$Showside.prefix("flex hide-on-empty")
      }, React.createElement(ProductSwatches$Showside.Minimal.make, {
        hideOutOfStock: hideOutOfStock,
        product: product,
        mainImage: image.url
      }), reviewSummary !== undefined ? React.createElement(ProductReviews$Showside.Summary.make, {
        at: /* PLP */1,
        summary: reviewSummary
      }) : null), React.createElement("div", {
        className: CSS$Showside.prefix("truncate mt-1")
      }, React.createElement(ProductPrice$Showside.make, tmp$1)), Belt_Option.getWithDefault(children, null))))
    };
    var tmp$3 = enableDataTestId ? "product-listitem-test-id" : undefined;
    if (tmp$3 !== undefined) {
      tmp$2.dataTestId = Caml_option.valFromOption(tmp$3);
    }
    return React.createElement(DataAttribute$Showside.make, tmp$2);
  });
}
ProductListItem.displayName = "ProductListItem";
var make = ProductListItem;
export { ListItemButton, make };
/* react Not a pure module */